import { PlusOutlined } from '@ant-design/icons';
import { Button, Form } from 'antd';

import { ColumnsHeader } from './ColumnsHeader';
import { ContactRow } from './ContactRow';
import styles from './ExtranetContacts.module.scss';
import {
  DEFAULT_EXTRANET_CONTACT,
  EMAIL_TYPE_COLUMNS,
  EXTRANET_CONTACTS_FIELD,
} from './columns';
import type { EmailTypeKey, ExtranetContact } from './columns';

export const ExtranetContacts = ({ isEditMode }: { isEditMode: boolean }) => {
  const contacts =
    Form.useWatch<ExtranetContact[]>(EXTRANET_CONTACTS_FIELD) ?? [];

  const checkedCounts = EMAIL_TYPE_COLUMNS.reduce(
    (acc, column) => {
      acc[column.key] = contacts.filter((contact) =>
        Boolean(contact?.[column.key])
      ).length;

      return acc;
    },
    {} as Record<EmailTypeKey, number>
  );

  return (
    <div className={styles.container}>
      <ColumnsHeader />

      <Form.List name={EXTRANET_CONTACTS_FIELD}>
        {(fields, { add, remove }) => (
          <>
            {fields.map((field, index) => (
              <ContactRow
                key={field.key}
                isEditMode={isEditMode}
                displayIndex={index}
                namePath={field.name}
                contact={contacts[field.name]}
                checkedCounts={checkedCounts}
                onRemove={() => remove(field.name)}
                canRemove={isEditMode && fields.length > 1}
              />
            ))}
            {isEditMode && (
              <Button
                className={styles.addButton}
                icon={<PlusOutlined />}
                onClick={() => add(DEFAULT_EXTRANET_CONTACT)}
              >
                Add contact
              </Button>
            )}
          </>
        )}
      </Form.List>
    </div>
  );
};
